import * as ng from 'angular';
import {uniqBy} from 'lodash-es';
import {IAuthenticatedUserService} from "../../types/ServiceTypes";
import {IRecentViewedService} from "../services/RecentViewedService";
import {DocMetadata} from "../../types/DocMetadata";
import ResourceIconService from "../../services/ResourceIconService";

export interface IScope extends ng.IScope {
    toHumanReadableDate: (date: string) => string;
    documents: DocMetadata[];
    loadingError: boolean;
    loadingInProgressFlag: boolean;
};

const MAX_NUM_ITEMS_TO_DISPLAY = 5;

angular.module('GorillaBoy.Dboard')
    .controller('RecentViewsComponentController', [
        '$scope',
        '$log',
        '$q',
        'authenticatedUser',
        'DateTimeService',
        'RecentViewedService',
        'DocumentService',
        'ResourceIconService',
        ($scope: IScope, $log: ng.ILogService, $q: ng.IQService, authenticatedUser: IAuthenticatedUserService,
         DateTimeService: any, RecentViewedService: IRecentViewedService, DocumentService: any,
         ResourceIconService: ResourceIconService) => {

            // Initialization
            $scope.documents = [];
            $scope.loadingInProgressFlag = true;
            $scope.loadingError = false;
            $scope.getFileIcon = ResourceIconService.getFileIcon;

            var userId = authenticatedUser.getUserInfo().Id;
            RecentViewedService.getRecentViewedFilesActivity(userId).then(function (recentViewedFilesActivities) {
                recentViewedFilesActivities = uniqBy(recentViewedFilesActivities.map(activity => activity.Fields), 'ResourceId');
                if (recentViewedFilesActivities.length > MAX_NUM_ITEMS_TO_DISPLAY) {
                    recentViewedFilesActivities.length = MAX_NUM_ITEMS_TO_DISPLAY;
                }
                var promises = recentViewedFilesActivities.map(FieldObj => {
                    return DocumentService.getDocument(FieldObj.ResourceId, true);
                });
                if (promises.length) {
                    $q.all(promises).then((responses: any) => {
                        $scope.documents = responses.map(response => response.data.Metadata) as DocMetadata[];
                    }, error => {
                        $log.error('error loading doc metadata inside recent viewed files ' + JSON.stringify(error));
                    })
                    .finally(() => {
                        $scope.loadingInProgressFlag = false;
                    });
                } else {
                    $scope.loadingInProgressFlag = false;
                }
            }, function (error) {
                $scope.loadingError = true;
                $scope.loadingInProgressFlag = false;
                $log.error('error loading recent viewed files ' + JSON.stringify(error));
            });
            // Utilities
            $scope.toHumanReadableDate = DateTimeService.getHumanReadableDate;
        }])
